const ROOT = "table-component";
const INSERT_TABLE_BUTTON = "insert-table-button";
const INSERT_TABLE_MODAL = "insert-table-modal";
const INSERT_TABLE_MODAL_ROWS_INPUT = "insert-table-modal-row-count";
const INSERT_TABLE_MODAL_COLUMNS_INPUT = "insert-table-modal-column-count";
const INSERT_TABLE_MODAL_ERROR_MESSAGE = "insert-table-modal-error-message";
const INSERT_TABLE_MODAL_FOOTER_ACTIONS = "insert-table-modal-footer-actions";
const TABLE_PLUS_BUTTON = "table-plus-button";
const TABLE_PLUGIN_CELL = "table-plugin-cell";
const PLUGIN_TOOLBAR_FORMATTING_BUTTON = "plugin-toolbar-text-style-button";
const PLUGIN_TOOLBAR_VERTICAL_ALIGNMENT_BUTTON = "plugin-toolbar-vertical-alignment-button";
const PLUGIN_TOOLBAR_BACKGROUND_COLOR_BUTTON = "plugin-toolbar-background-color-button";
const PLUGIN_TOOLBAR_BORDER_COLOR_BUTTON = "plugin-toolbar-border-color-button";
const PLUGIN_TOOLBAR_CONTEXT_MENU_BUTTON = "plugin-toolbar-context-menu-button";
const PLUGIN_TOOLBAR_ROW_HEADER_BUTTON = "plugin-toolbar-row-header-button";
const PLUGIN_TOOLBAR_COLUMN_HEADER_BUTTON = "plugin-toolbar-column-header-button";
export {
  INSERT_TABLE_BUTTON,
  INSERT_TABLE_MODAL,
  INSERT_TABLE_MODAL_COLUMNS_INPUT,
  INSERT_TABLE_MODAL_ERROR_MESSAGE,
  INSERT_TABLE_MODAL_FOOTER_ACTIONS,
  INSERT_TABLE_MODAL_ROWS_INPUT,
  PLUGIN_TOOLBAR_BACKGROUND_COLOR_BUTTON,
  PLUGIN_TOOLBAR_BORDER_COLOR_BUTTON,
  PLUGIN_TOOLBAR_COLUMN_HEADER_BUTTON,
  PLUGIN_TOOLBAR_CONTEXT_MENU_BUTTON,
  PLUGIN_TOOLBAR_FORMATTING_BUTTON,
  PLUGIN_TOOLBAR_ROW_HEADER_BUTTON,
  PLUGIN_TOOLBAR_VERTICAL_ALIGNMENT_BUTTON,
  ROOT,
  TABLE_PLUGIN_CELL,
  TABLE_PLUS_BUTTON
};
//# sourceMappingURL=data-hooks.js.map
